<template>
  <div>
    <Toolbar :handle-delete="del">
      <template slot="left">
        <v-toolbar-title v-if="item">{{
          `${$options.servicePrefix} ${item['@id']}`
        }}</v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-credittransfer-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('Field') }}</th>
              <th>{{ $t('Value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('amount') }}</strong></td>
              <td>
                {{ $n(item['amount']['amount'] / 100, 'currency', 'de-DE') }} {{ item['amount']['currency'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('remittanceInfo') }}</strong></td>
              <td>
                {{ item['remittanceInfo'] }}
              </td>
            </tr>
            <tr>
                <td><strong>{{ $t('endToEndId')}}</strong></td>
                <td>
                    {{ item['endToEndId'] }}
                </td>
            </tr>
            <tr v-if="creditor">
              <td><strong>{{ $t('creditor') }}</strong></td>
              <td>
                <sepa-info-table v-if="creditor['sepaInfo']" :item="creditor['sepaInfo']"></sepa-info-table>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';
import SepaInfoTable from "../../components/party/SepaInfoTable";

const servicePrefix = 'CreditTransfer';

export default {
  name: 'CreditTransferShow',
  servicePrefix,
  components: {
      SepaInfoTable,
      Loading,
      Toolbar
  },
  mixins: [ShowMixin],
    computed: {
    ...mapFields('credittransfer', {
      isLoading: 'isLoading'
    }),
    creditor() {
        if (this.item['creditor']) {
          return this.find_creditor(this.item['creditor']);
        }
        return {name: ''};
    },
    ...mapGetters('credittransfer', ['find']),
    ...mapGetters('party', {'find_creditor': 'find'})
  },
  watch: {
    item(i) {
      if (i) {
        this.retrieve_creditor(i['creditor']);
      }
    }
  },
  methods: {
    ...mapActions('credittransfer', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('party', {
      retrieve_creditor: 'load'
    })
  }
};
</script>
